<template>
  <div class="mb-4 rounded-lg border border-neutral-50 bg-white-500">
    <div class="p-4 sm:p-4 md:px-4">
      <div
        class="flex items-center gap-2"
        :class="[
          ' text-neutral-950',
          !expanded && !forceOpen
            ? 'cursor-pointer hover:text-primary-500'
            : '',
        ]"
      >
        <TIcon :name="props.icon" class="mr-2 h-8 w-8" v-if="props.icon" />
        <div class="grow" @click="expanded = !expanded">
          <TH2 v-if="props.title">
            {{ props.title }}
          </TH2>
          <TPCaption v-if="props.subTitle" class="mt-1">
            {{ props.subTitle }}
          </TPCaption>
        </div>
        <div class="" v-if="!forceOpen">
          <TIcon
            v-if="expanded"
            name="angle_up"
            class="cursor-pointer"
            @click="expanded = !expanded"
          />
          <TIcon
            v-if="!expanded"
            name="angle_down"
            class="cursor-pointer"
            @click="expanded = !expanded"
          />
        </div>
      </div>
      <div class="mt-4" v-if="expanded || forceOpen">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title?: string;
  subTitle?: string;
  icon?: string;
  forceOpen?: boolean;
}>();

const expanded = ref(false);
</script>
